import { SuggestionKind } from 'owa-search-service';

export type SupportedFilesHubSuggestionKindType =
    | SuggestionKind.Files
    | SuggestionKind.People
    | SuggestionKind.Keywords;
export const SUPPORTED_FILESHUB_SUGGESTION_KIND_LIST = [
    SuggestionKind.Files,
    SuggestionKind.People,
    SuggestionKind.Keywords,
];
export const ALL_SUGGESTION_KINDS_LIST = [
    SuggestionKind.Files,
    SuggestionKind.People,
    SuggestionKind.Keywords,
    SuggestionKind.Message,
    SuggestionKind.Category,
];
